export default __webpack_public_path__ + "static/media/HV_Icones_Plan.2cccd798.svg";